<template>
  <div id="formQuestion">
    <div class="center-container">
      <div class="container-box pr-4 pl-4">
        <div v-if="!questionSent">
          <h3 class="text-center mb-3">
            Participez en ajoutant vos propre questions !
          </h3>
          <b-form>
            <b-form-input
              :class="{'border-danger': invalidQuestion}"
              class="mb-3"
              v-model="question"
              type="text"
              placeholder="Question"
            ></b-form-input>
            <p v-if="invalidQuestion" class="pr-3 pl-3 text-danger">
              Question Invalide, veuillez réessayer. 
            </p>
            <b-button @click="writeUserQuestion" class="mb-2 mx-auto w-100 login-btn">
              Envoyer
            </b-button>
          </b-form>
        </div>
        <div class="center-container" v-if="questionSent && !invalidQuestion">
          <h3 class="text-center mb-3">
            Merci d'avoir contribué au jeu kawaa !
          </h3>
          <b-button class="add-btn" @click="writeAnotherQuestion">
            Envoyer une nouvelle question !
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'formQuestion',
  data () {
    return {
      db: firebase.database().ref(),
      dbData: [],
      status: '',
      question: '',
      update: [],
      questionSent: false,
      invalidQuestion: false
    }
  },
  created: function () {
    this.db.on('value', (snapshot) => {
      this.dbData = snapshot.val()
    })
  },
  methods: {
    writeUserQuestion: function () {
      const toUpdate = {}
      toUpdate[this.dbData.length] = {
        status: 'pending',
        question: this.question
      }
      if (this.question.length > 0) {
        this.questionSent = true
        this.invalidQuestion = false
        firebase.database().ref().update(toUpdate)
      } else {
        this.invalidQuestion = true
      }
    },
    writeAnotherQuestion: function () {
      this.question = ''
      this.questionSent = false
      this.invalidQuestion = false
    }
  }
}
</script>

<style>
.center-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 85vh;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
}

.container-box {
  display: flex;
  flex-direction: column;
  min-width: 270px;
}
.add-btn {
    color: #fff;
    background-color: #0a1128;
  }
</style>



// WEBPACK FOOTER //
// src/views/FormQuestionComponent.vue